import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CouponsectionService } from 'src/app/services/couponsection.service';
import { PollsandsurveyService } from 'src/app/services/pollsandsurvey.service';
import { Pollsandsurvey } from 'src/app/model/pollsandsurvey.model';

@Component({
  standalone: false,
  selector: 'app-assign-coupon',
  templateUrl: './assign-coupon.component.html',
  styleUrls: ['./assign-coupon.component.scss'],
})
export class AssigncouponComponent implements OnInit {

  public pollsandsurvey = new Pollsandsurvey();

  @Input() couponId: string;
  @Input() fromDetailsPage: any;
  @Input() fromListPage: any;
  @Input() couponlist: any;
  @Input() couponTitle: any;

  listCouponIds = [];
  mainCouponList = [];
  searchText: string = '';
  page: any;
  totalPages = 1;
  indexPage = 1;
  pageNo: number = 0;
  pageSize: number = 20;
  totalRows: number = 0;
  couponIdToAssign: any;
  couponTitleToAssing: any;
  isCouponDataFound: any;

  myForm!: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private customergroupService: CouponsectionService,
    private pollsandsurveyService: PollsandsurveyService,
  ) {
    this.myForm = this.formBuilder.group({
      deletedBy: '',
      userId: ''
    });
  }

  ngOnInit(): void {
    this.getTheCouponsList();
    console.log(this.couponIdToAssign);
    this.pollsandsurvey.couponId = this.couponIdToAssign ? this.couponIdToAssign : this.couponId;
    this.isCouponDataFound = 1;
  }

  getCouponId(id, couponTitle) {
    this.couponIdToAssign = id;
    this.couponTitleToAssing = couponTitle;
    console.log(this.couponIdToAssign);
    console.log(this.couponTitleToAssing);
    // this.pollsandsurvey.couponId = id;
  }

  getTheCouponsList() {
    this.pollsandsurveyService.getCouponList().subscribe((res) => {
      if (res?.isValid === true) {
        //this.mainCouponList = res?.list;
        this.mainCouponList = res?.list.filter((item: { isActive: any }) => {
          return item.isActive === true;
        });
        if (this.mainCouponList.length == 0) {
          this.isCouponDataFound = 0;
        } else {
          this.isCouponDataFound = 1;
        }
      } else {
        this.mainCouponList = [];
        this.isCouponDataFound = 0;
      }
    });
  }

  assignCouponData() {
    console.log(this.couponIdToAssign);
    console.log(this.couponTitleToAssing);
    console.log(this.couponId);
    console.log(this.couponTitle);

    if (this.couponIdToAssign == undefined || this.couponIdToAssign == 'undefined') {
      this.pollsandsurveyService.setOptionDynamic('coupon_id', this.couponId);
    } else {
      this.pollsandsurveyService.setOptionDynamic('coupon_id', this.couponIdToAssign);
    }
    if (this.couponTitleToAssing == undefined || this.couponTitleToAssing == 'undefined') {
      this.pollsandsurveyService.setOptionDynamic('coupon_title', this.couponTitle);
    } else {
      this.pollsandsurveyService.setOptionDynamic('coupon_title', this.couponTitleToAssing);
    }

    // if (this.couponId == undefined || this.couponId == 'undefined') {
    //   this.pollsandsurveyService.setOptionDynamic('coupon_id', this.couponIdToAssign);
    // } else {
    //   this.pollsandsurveyService.setOptionDynamic('coupon_id', this.couponId);
    // }
    // if (this.couponTitle == undefined || this.couponTitle == 'undefined') {
    //   this.pollsandsurveyService.setOptionDynamic('coupon_title', this.couponTitleToAssing);
    // } else {
    //   this.pollsandsurveyService.setOptionDynamic('coupon_title', this.couponTitle);
    // }
    this.modal.dismiss();
  }
}
